import { render } from "./UploadImgPanel.vue?vue&type=template&id=2e480720"
import script from "./UploadImgPanel.vue?vue&type=script&lang=js"
export * from "./UploadImgPanel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__